import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as labs from 'vuetify/labs/components'
import * as directives from 'vuetify/directives'

import '@fontsource/poppins/400.css'
import '@fontsource/poppins/600.css'

const defaultTheme = {
  dark: true,
  colors: {
    background: '#121212', // dunkler Grundton
    surface: '#1E1E1E', // Karten / Dialogs
    primary: '#D38B2E', // warmes Orange = Appetitfarbe
    'primary-darken-1': '#A46B22', // etwas dunkler für Hover
    secondary: '#91A66B', // muted green = Frische
    'secondary-darken-1': '#6F8452', // dunklere Akzentvariante
    error: '#E6543D', // leicht rötlicher für dunkles UI
    info: '#4DA3D1',
    success: '#7EC27E',
    warning: '#E9B44C',
  },
}

export const vuetify = createVuetify({
  components: {
    ...labs,
    ...components,
  },
  directives,
  defaults: {
    global: {
      style: {
        fontFamily: 'Poppins, sans-serif',
      },
    },
  },
  theme: {
    defaultTheme: 'defaultTheme',
    themes: {
      defaultTheme,
    },
  },
})
